<script lang="ts">
  import { onMount } from "svelte";

  import Window from "../components/Window.svelte";
  import type { Rect, WinCbs, WinProps } from "../scripts/WinTypes";
  import { addLog, logs } from "../stores/LoggerStore";
  import { get } from "svelte/store";

  import ProcMgr from "../stores/ProcMgr";
  import SessMgr from "../stores/SessMgr";
  import axios from "axios";
  import { derived } from "svelte/store";
  import { filesInDirectory } from "../scripts/FileTypes";
  import { FileMgr } from "../stores/FileMgr";
  import SettingsMgr from "../stores/SettingsMgr";

  export let winProps: WinProps;
  winProps.name = winProps.name || "Logger";
  const callbacks: WinCbs = {
    onFocus: () => {
      logsElem.focus();
      return true;
    },
  };
  const setProps = () => {
    if (!winProps.data) {
      winProps.data = {};
    }
    winProps.data =
      winProps.data.rect ||
      <Rect>{
        top: "40%",
        left: "40%",
        width: "50%",
        height: "50%",
      };
  };
  setProps();

  let theme = SettingsMgr.getInstance().theme;
  let procmgr = ProcMgr.getInstance();
  let logsElem;
  let { procStore } = procmgr;
  let dirs = FileMgr.getInstance().dirs;
  let files = FileMgr.getInstance().files;

  onMount(() => {
    addLog("Logger mounted");
    logsElem.focus();
  });

  let cookieString = document.cookie;
  let homedir = FileMgr.getInstance().home;
  let ordered = derived(ProcMgr.getInstance().winStoreOrdered, (procs) =>
    [...procs].reverse()
  );
  let prefix = (logtype) => {
    switch (logtype) {
      case 2:
        return "[Warn]";
      case 3:
        return "[Error]";
      case 4:
        return "[System]";

      default:
        return "";
    }
  };

  const setmgr = SettingsMgr.getInstance();
  $: settingKeys = derived(setmgr.settingsStore, (settings) => {
    const keys = <string[]>[];
    for (let key in settings) {
      keys.push(key);
    }
    return keys;
  });
  onMount(() => {});
</script>

<Window {winProps} {callbacks}>
  <div class="logs">
    <div class="l">
      <ul bind:this={logsElem}>
        {#each $logs as log (log.id)}
          <li class={`item-${log.type}`}>{prefix(log.type)}{log.log}</li>
        {/each}
      </ul>
    </div>
    <div class="r">
      <div class="r-item">
        * ProcStore
        <div class="ll">
          Store id/name
          {#each $procStore as store (store.id)}
            <div class="store-value">Id[{store.id}] : {store.props.name}</div>
          {/each}
        </div>
        <div class="rr">
          Store id/index
          {#each $ordered as store (store.id)}
            <div class="store-value">
              Id[{store.id}] index : {store.props.zIndex}
            </div>
          {/each}
        </div>
      </div>

      <div class="r-item">
        * File count
        <div class="dir">Dirs : {filesInDirectory($homedir).totalDirs}</div>
        <div class="file">Files : {filesInDirectory($homedir).totalFiles}</div>
        <div class="dir">Dir : {$dirs.map((dir) => dir.node.path.path)}</div>
        <div class="file">
          Files : {$files.map((dir) => dir.node.path.path)}
        </div>
      </div>
      <div class="r-item">
        * Settings :<br />
        - Current theme : {$theme.name}<br />
        <ol>
          {#each $settingKeys as key (key)}
            <li>{key} :{"" + setmgr.getValue(key)}</li>
          {/each}
        </ol>
      </div>
    </div>
  </div>
</Window>

<style>
  .item-4 {
    color: lime;
  }
  .item-3 {
    color: Red;
  }
  .item-2 {
    color: yellow;
  }
  .logs {
    display: flex;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    justify-content: space-between;
  }
  .api-url {
    resize: none;
    white-space: nowrap;
    overflow: hidden;
  }
  .l,
  .r {
    flex: 1;
    overflow: auto;
  }
  .r {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .r-item {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .h2 {
    flex: 2;
  }
  .store-value {
    font-weight: 300;
  }
  ul {
    box-sizing: border-box;
    /* overflow-y: scroll; */
    overflow: auto;
    width: 100%;
    /* height: 100%; */
    padding: 0;
    margin: 0;
    padding-left: 20px;
  }

  li {
    margin: 0;
    font-size: 0.9rem;
    word-wrap: break-word;
  }
  .l {
    background-color: #333;
    color: #efefef;
  }
</style>
